import { DocumentReportGenerator } from './documentReportGenerator';
export type { PDFGeneratorConfig } from '../reportUtils/base';
export { BasePDFGenerator } from '../reportUtils/base';
export { DocumentReportGenerator } from './documentReportGenerator';
export type { FieldVisibilityConfig } from './types';

import { DocumentConciliationRateHistory } from '../../../../../../lib/common/GeneralComponents/DocumentProfile/components/types';
import { FieldVisibilityConfig } from './types';

export const generateDocumentReportPDF = async (
  document: any,
  userName: string,
  imageBase64: string,
  fieldVisibility?: FieldVisibilityConfig,
  rateHistory?: DocumentConciliationRateHistory,
) => {
  const generator = new DocumentReportGenerator({
    userName,
    imageBase64,
    title: 'Detalle Documento',
    fileName: `REPORTE-${document.businessName}-${document.folio}.pdf`,
    document,
    fieldVisibility,
    rateHistory,
  });

  await generator.generate();
};
